import * as THREE from 'three'
import Experience from '../Experience.js'
import Environment from './Environment.js'
import Floor from './Floor.js'
import Fox from './Fox.js'
// import Cube from './Cube.js'
import Fish from "./Fish.js"
import Salmon from "./Salmon.js"
import Alosa from "./Alosa.js"
import Eel from "./Eel.js"
import Boat from "./Boat.js"
import FishingBoat from "./FishingBoat.js"
// import Windmills from "./Windmills.js"
// import Windmill from "./Windmill.js"
import Kingfisher from "./Kingfisher.js"
import Otter from "./Otter.js"
import Dragonfly from "./Dragonfly.js"
import Tree from "./Tree.js"
import Poplar from "./Poplar.js"
import Flowers from "./Flowers.js"
import Walls from "./Walls.js"
import WallsOuter from "./WallsOuter.js"
import Sky from "./Sky.js"

export default class World {
    constructor(onReadyCallback) {
        this.experience = new Experience()
        this.scene = this.experience.scene // Need access to the scene
        this.resources = this.experience.resources

        // Fog (also modified in Teleports, not required here anymore since it gets overwritten)
        // this.scene.fog = new THREE.Fog(0xeefbff, 20, 85);
        // this.scene.fog = new THREE.Fog(0xeefbff, 20, 85);
        // this.scene.fog = new THREE.FogExp2(0xf0f8ff, 0.02);
        // this.scene.fog = new THREE.Fog(0xeefbff, 10, 25);
        // Doesn't affect the sky?
        // this.scene.fog = new THREE.Fog(0x7dabd9, 15, 47);
        // this.scene.fog = new THREE.Fog(0x70abd0, 
        // this.scene.fog = new THREE.Fog(0x87ceeb, 15, 30);
        // this.scene.fog = new THREE.Fog(0x87ceeb, 10, 20);
        // this.scene.fog = new THREE.FogExp2(0xf0f8ff, 0.04);

        // Wait for resources
        this.resources.on('ready', () => {
            // Setup
            this.floor = new Floor()
            // this.fox = new Fox()
            // this.cube = new Cube()
            this.fish = new Fish()
            this.salmon = new Salmon()
            this.eel = new Eel()
            this.alosa = new Alosa()
            this.boat = new Boat()
            this.boat2 = new Boat(10, '#003399')
            this.fishingBoat = new FishingBoat()
            this.kingfisher = new Kingfisher()
            this.otter = new Otter()
            this.dragonfly = new Dragonfly()
            this.tree = new Tree()
            this.poplar = new Poplar()
            this.flowers = new Flowers()
            this.sky = new Sky()
            this.walls = new Walls()
            this.wallsOuter = new WallsOuter()
            this.environment = new Environment() // Only create environment map when resources are ready. Needs to be last

            // Call the callback function once everything is ready. All animated objects go here
            if (onReadyCallback) {
                // onReadyCallback(this.cube, this.fish, this.boat, this.windmills, this.kingfisher, this.otter);
            }
        })
    }

    update() {
        // All animated objects go here
        if (this.fish) {
            this.fish.update()
        }
        if (this.alosa) {
            this.alosa.update()
        }
        if (this.eel) {
            this.eel.update()
        }
        if (this.salmon) {
            this.salmon.update()
        }
        if (this.boat) {
            this.boat.update()
        }
        if (this.boat2) {
            this.boat2.update()
        }
        if (this.windmills) {
            this.windmills.update()
        }

        // if (this.windmill) {
        //     this.windmill.update()
        // }

        if (this.kingfisher) {
            this.kingfisher.update()
        }

        if (this.dragonfly) {
            this.dragonfly.update()
        }

        if (this.otter) {
            this.otter.update()
        }

        if (this.flowers) {
            // this.flowers.update() // For LOD
        }

        // if (this.tree) {
        //     this.tree.update() // For LOD
        // }

        // if (this.poplar) {
        //     this.poplar.update() // For LOD
        // }
        // if (this.cube) {
        //     // this.experience.changeAnimation.toggleAnimation()
        // }
    }
}